import { render, staticRenderFns } from "./ActorRoleCreate.vue?vue&type=template&id=38b86bcb&"
import script from "./ActorRoleCreate.vue?vue&type=script&lang=js&"
export * from "./ActorRoleCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports